import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import AssignSKUPage from 'pages/replenish/assign-replenish-task/AssignSKUPage';
import {
  ReplenishListDestinationPage,
  ReplenishListSourcePage,
} from 'pages/replenish/replenish-list';
import { ReplenishSummaryPage } from 'pages/replenish/replenish-summary';
import {
  ReplenishTaskDestinationPage,
  ReplenishTaskSourcePage,
} from 'pages/replenish/replenish-task';

import {
  REPLENISH_ROUTE_ROOT,
  REPLENISH_ROUTES,
} from './constants/replenish-routes.constant';

export const useReplenishRouter = (): React.JSX.Element => (
  <Route
    path={REPLENISH_ROUTE_ROOT}
    element={
      <PrivateRoute
        roles={[
          UserRolesEnum.SUPER_ADMIN,
          UserRolesEnum.ADMIN,
          UserRolesEnum.REPLENISH,
        ]}
      />
    }
  >
    <Route
      path={REPLENISH_ROUTES.REPLENISH}
      element={<Navigate to={REPLENISH_ROUTES.ASSIGN} />}
    />
    <Route path={REPLENISH_ROUTES.ASSIGN} element={<AssignSKUPage />} />
    <Route
      path={REPLENISH_ROUTES.LIST_SOURCE}
      element={<ReplenishListSourcePage />}
    />
    <Route
      path={REPLENISH_ROUTES.LIST_DESTINATION}
      element={<ReplenishListDestinationPage />}
    />
    <Route
      path={REPLENISH_ROUTES.TASK_SOURCE}
      element={<ReplenishTaskSourcePage />}
    />
    <Route
      path={REPLENISH_ROUTES.TASK_DESTINATION}
      element={<ReplenishTaskDestinationPage />}
    />
    <Route path={REPLENISH_ROUTES.SUMMARY} element={<ReplenishSummaryPage />} />
  </Route>
);
